import {
  CancelMembershipThunk,
  PurchaseSubscriptionThunk,
  subscriptionsManagementSetSubscriptionsThunk,
  subscriptionsManagementSetUserSubscriptionsThunk,
} from './subscriptionsManagementActions';
import { useAppAction, useAppSelector } from '../hooks';
import { SubscriptionsManagementState } from './subscriptionsManagementTypes';
import { SUBSCRIPTIONS_MANAGEMENT_NAMESPACE } from './subscriptionsManagementReducer';

export function useCreditsManagementSelector<
  T extends (state: SubscriptionsManagementState) => any
>(selector: T): ReturnType<T> {
  return useAppSelector((state) =>
    selector(state[SUBSCRIPTIONS_MANAGEMENT_NAMESPACE])
  );
}

export const useSubscriptions = () =>
  useCreditsManagementSelector((state) => {
    return state.subscriptions;
  });

export const useUsersSubscriptions = () =>
  useCreditsManagementSelector((state) => {
    return state.user.subscriptions;
  });

export const useFetchSubscriptions = () =>
  useAppAction(subscriptionsManagementSetSubscriptionsThunk);

export const useFetchUserSubscriptions = () =>
  useAppAction(subscriptionsManagementSetUserSubscriptionsThunk);

export const usePurchaseSubscription = () =>
  useAppAction(PurchaseSubscriptionThunk);

export const useCancelMembership = () => useAppAction(CancelMembershipThunk);
